import apiService from './apiService';

/** Événement : bulle TopBar à masquer après visite de la messagerie */
export const NOTIFICATIONS_CLEARED_EVENT = "notifications:cleared";

class NotificationService {
  /**
   * Liste les notifications du client connecté (les plus récentes d'abord)
   */
  async getMyNotifications() {
    const response = await apiService.get('/notifications');
    return response.data;
  }

  /**
   * Nombre de notifications non lues
   */
  async getUnreadCount() {
    const response = await apiService.get('/notifications/unread-count');
    return response.count ?? 0;
  }

  /**
   * Marquer une notification comme lue
   */
  async markAsRead(id) {
    return apiService.post(`/notifications/${id}/read`);
  }

  /**
   * Marquer toutes les notifications comme lues
   */
  async markAllAsRead() {
    return apiService.post('/notifications/read-all');
  }
}

const notificationService = new NotificationService();
export default notificationService;
